import NavigationBar from "../../../navigation_components/NavigationBar";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Accounts/Account.css";
import Profile from "./Profile";
import { useState } from "react";
import Security from "./Security";
import ServerConnections from "./ServerConnections";
import BottomRightMessageBox from "../../UniversalComponents/BottomRightMessageBox";
import NewServerConnection from "./NewServerConnection";
import EditServerConnection from "./EditServerConnection";
import DeleteServerConnection from "./DeleteServerConnection";

const Account = () =>{
    const [selectedAccountTab,setSelectedAccountTab] = useState('profile');
    return(
        <div className="tenant-administrator-account-page">
            <NavigationBar/>
            <div className="tenant-administrator-account-page-layout">
                <div>
                    <TenantAdministratorSideBar/>
                </div>
                <div className="tenant-administrator-account-parent-container">
                    <div className="tenant-administrator-account-container">
                        <div className="tenant-administrator-account-navigation-bar">
                            <button className={selectedAccountTab === 'profile'? 'active':''}
                                onClick={() =>setSelectedAccountTab('profile')}>
                                <img src={`${process.env.PUBLIC_URL}/images/user-icon-blue.png`}/>
                                <p>Profile</p>
                            </button>
                            <button className={selectedAccountTab === 'server-connections'? ' active':''}
                                onClick={() => setSelectedAccountTab('server-connections')}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/server-connections-icon.png`}
                                />
                                <p>Server Connections</p>
                            </button>
                            <button className={selectedAccountTab === 'security'? 'active':''}
                                onClick={() => setSelectedAccountTab('security')}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/security-config-icon.png`}
                                />
                                <p>Security</p>
                            </button>
                        </div>
                        <div className="tenant-administrator-account-body">
                            {selectedAccountTab === 'profile'? <Profile/>:
                            selectedAccountTab === 'server-connections'? <ServerConnections/>:<Security/>}
                        </div>
                    </div>
                </div>
            </div>
            <NewServerConnection/>
            <EditServerConnection/>
            <DeleteServerConnection/>
            <BottomRightMessageBox/>
        </div>
    );
};
export default Account;